export const brandNames: { [key: string]: string } = {
  seat: 'SEAT',
  vw: 'Volkswagen',
  vwcv: 'Volkswagen Véhicules Utilitaires',
  audi: 'Audi',
  cupra: 'SEAT',
  vwfs: 'Volkswagen'
};
